module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHLANDS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is a legend about the founding of Highlands. It is said that two developers took a map and drew a line from New York City to New Orleans, then drew another line between Chicago and Savannah. They saw these routes as the great trade routes of the future, and of course where they crossed on the map would be a great population center, full of commerce and bustling activity. So they set out to settle that crossroads where the two lines met. It was Highlands, sitting high on a mountain plateau, with an elevation of 4,118 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Obviously, Highlands never became the commercial center for which the pioneers had hoped. Anchored by a few blocks of Main Street, Highlands spreads out in residential communities and country clubs east toward Cashiers, west toward Franklin and south toward Rabun County, Georgia. But it has always remained mostly a seasonal town, with summers bringing well-heeled tourists from Atlanta and the winter left to the roughly nine hundred residents who call it home year-round.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Looking west on Main Street in Highlands. "), _c('i', [_vm._v("Photo courtesy of the")]), _vm._v(" Highlander.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Looking east on Main Street in Highlands. "), _c('i', [_vm._v("Photo courtesy of the")]), _vm._v(" Highlander.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/img15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Highlands Sanatorium, or “Bug Hill,” was a social and medical center in Highlands. All the little buildings situated in rows on the hill are the open-air “tents” for tuberculosis patients. "), _c('i', [_vm._v("Photo circa 1910, courtesy of the Highlands Historical Society")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite its small size, it has always been a destination in the southwest North Carolina mountains. Dr. Mary Lapham, noted for her Swiss therapy for tuberculosis, opened Highlands Sanatorium, which soon became a social center and employer for many people in the town. “Bug Hill,” as it became commonly known, brought people from Atlanta, Asheville, Savannah and Charleston for a cure through crisp mountain air and a variety of tuberculosis treatments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It next became a destination for golf when a new golf course in Highlands became a practice course for legendary golfer Bobby Jones. Construction of courses expanded as the game’s popularity increased, and today golfing is a large part of Highlands culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Highlands’s modern era has seen a juxtaposition of the old and new. High-boutique shops and a lavish spa share the same street with a pharmacy that still has a lunch counter and an old inn that does not have central heating. Old buildings sit next to new ones, and hikers, shoppers and mountain folk mix on the same street.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 78
// module chunks = 0